import { FC, memo } from 'react'
import { Center, Text } from '@chakra-ui/react'

import { useCalendarFilters } from '../../../../contexts/CalendarFiltersManager/Provider'

type Props = {
  day?: number
  stringDate: string
  isThisMounth?: boolean
}

const SingleCalendarItem: FC<Props> = ({ day, stringDate, isThisMounth }) => {
  const { startDate, setStartDate } = useCalendarFilters()

  const isSelectedDate = stringDate === startDate

  let textColor = 'dark'
  let bgColor = 'light'

  if (isSelectedDate) {
    textColor = 'light'
    bgColor = 'primary'
  }

  return (
    <Center
      opacity={isThisMounth ? '1' : '0'}
      boxSize="8"
      rounded="sm"
      transition="all 250ms"
      cursor="pointer"
      bg={bgColor}
      color={textColor}
      _hover={{ bg: 'primary', color: 'light' }}
      onClick={() => setStartDate(stringDate)}
    >
      <Text>{day}</Text>
    </Center>
  )
}

export default memo(SingleCalendarItem)
